import { handleActions } from 'redux-actions';
import http from '../shared/http';
import intl from '../shared/intl';
import endpoints from '../../config/endpoints';

import cloneDeep from 'lodash/cloneDeep';

// action types
const GET_TARGETING_LOCATIONS_ERROR  = 'survey/get-targeting-locations-error';
const GET_TARGETING_LOCATIONS_SUCCESS = 'survey/get-targeting-locations-success';

const SAVE_SURVEY_ERROR = 'survey/save-survey-error';
const SAVE_SURVEY_SUCCESS = 'survey/save-survey-success';

const SET_MANAGER_ERROR = 'survey/set-manager-error';
const SET_MANAGER_SUCCESS = 'survey/set-manager-success';

// initialState state
const initialState = {
	targetingLocations: [],
	trafficSources: []
};

// actions
export const actions = {
	getTargetingLocations: () => (dispatch) => {
		let urls = [];
		if (process.env.CPA_ENV === 'everad') {
			urls.push(endpoints.LOOKUPS.TARGETING_LOCATIONS);
		}

		http({
			url: urls,
			method:'get',
			actions:[
				GET_TARGETING_LOCATIONS_SUCCESS,
				GET_TARGETING_LOCATIONS_ERROR
			]
		})(dispatch);
	},
	saveSurvey: (survey) => (dispatch) => {
		let urls = [];
		if (process.env.CPA_ENV === 'everad') {
			urls.push(endpoints.PROFILE.SURVEY);
		}

		http({
			url: urls,
			method:'put',
			actions:[
				SAVE_SURVEY_SUCCESS,
				SAVE_SURVEY_ERROR
			],
			data: survey
		})(dispatch);
	},
	setManager: () => (dispatch) => {
		let urls = [];
		if (process.env.CPA_ENV === 'everad') {
			urls.push(endpoints.PROFILE.MANAGER);
		}

		http({
			url: urls,
			method:'put',
			actions:[
				SET_MANAGER_SUCCESS,
				SET_MANAGER_ERROR
			]
		})(dispatch);
	}
};

// reducers
const reducers = {
	[GET_TARGETING_LOCATIONS_SUCCESS]: (state, action) => {
		return {
			...state,
			targetingLocations: action.payload[0].data
		};
	},
	[GET_TARGETING_LOCATIONS_ERROR]: state => {
		return { ...state, error: true };
	},
	[SAVE_SURVEY_SUCCESS]: state => {
		window.location.assign('/manager');
		return { ...state };
	},
	[SAVE_SURVEY_ERROR]: state => {
		return { ...state, error: true };
	},
	[SET_MANAGER_ERROR]: state => {
		return { ...state, error: true };
	}
};

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getTargetingLocations: state => state.survey.targetingLocations,
	getManagerContacts: state => state.managerPopup.manager,
	getTrafficSources: state => state.app.lists['traffic-sources']
		.map(x => x)
		.sort((a, b) => a.id === 'other' ? 1 : a.text > b.text ? 1 : -1),
	getNiches: state => state.app.lists['niches']
		.map(x => x)
		.sort((a, b) => a.id === 'Other' ? 1 : a.text > b.text ? 1 : -1),
	getUserData: state => state.app.userData,
	getIntl: state => intl(state)
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/survey/index.js